var _rect, _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMirror(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: "128px",
    height: "128px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 120,
    x: 19,
    y: 4,
    fill: "#e4e8ed"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.14,82.32c-0.68,0-1.36-0.23-1.93-0.7c-1.27-1.06-1.44-2.96-0.37-4.23l25.71-30.64 c1.06-1.27,2.96-1.44,4.23-0.37c1.27,1.06,1.43,2.96,0.37,4.23L53.44,81.25C52.85,81.96,52,82.32,51.14,82.32z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M54,56.92c-0.68,0-1.36-0.23-1.93-0.7c-1.27-1.06-1.44-2.96-0.37-4.23l10-11.92 c1.06-1.27,2.96-1.43,4.23-0.37c1.27,1.06,1.43,2.96,0.37,4.23l-10,11.92C55.71,56.55,54.85,56.92,54,56.92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59,94.96c-0.68,0-1.36-0.23-1.93-0.7c-1.27-1.06-1.44-2.96-0.37-4.23l10-11.92 c1.06-1.27,2.96-1.43,4.23-0.37c1.27,1.06,1.43,2.96,0.37,4.23l-10,11.92C60.71,94.59,59.85,94.96,59,94.96z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#444b54",
    d: "M109,1H19c-1.66,0-3,1.34-3,3v120c0,1.66,1.34,3,3,3h90c1.66,0,3-1.34,3-3V4C112,2.34,110.66,1,109,1z M106,121H22V7h84V121z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirror);
export default __webpack_public_path__ + "static/media/mirror.eb7c6d35.svg";
export { ForwardRef as ReactComponent };